import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('@/views/Login.vue') },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/calendar',
    children: [
      { path: 'calendar',  component: () => import('@/views/Calendar.vue') },
      { path: 'workflows', component: () => import('@/views/Workflows.vue') },
      { path: 'import',    component: () => import('@/views/Import.vue') },
      { path: 'entities',  component: () => import('@/views/Entities.vue') },
      { path: 'calls',     component: () => import('@/views/Calls.vue') },
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('todo_token')
  if (to.path !== '/login' && !token) return next('/login')
  if (to.path === '/import') {
    const roles = JSON.parse(localStorage.getItem('todo_roles') || '[]')
    if (!roles.includes('admin')) return next('/')
  }
  next()
})

export default router